import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "eventCard" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = {
  key: 0,
  class: "time"
}
const _hoisted_4 = { class: "city" }
const _hoisted_5 = { class: "green" }
const _hoisted_6 = { class: "gray" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CalendarIcon = _resolveComponent("CalendarIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.event !== null)
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: { name: 'Event', params: { id: _ctx.event.id } },
        class: "boxMessage"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_CalendarIcon, {
                date: _ctx.event.datetime
              }, null, 8, ["date"]),
              (_ctx.event.datetime)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$moment(_ctx.event.datetime).format("DD.MM.yyyy hh:mm")), 1))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.event.city), 1),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.event.venue), 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.event.venue_description), 1),
              _hoisted_7,
              _createElementVNode("h2", null, _toDisplayString(_ctx.event.title), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.event.summary), 1)
            ]),
            (_ctx.event.image_url)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.event.image_url
                }, null, 8, _hoisted_8))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["to"]))
    : _createCommentVNode("", true)
}